<template>
  <div class="ui" :class="{move: isBallMove}">
    <!--接口-->
    <component :is="SDKComponentMessage.interfaceName"> </component>
    <!--接口 融合公告-->
    <component :is="notice"> </component>
    <!--接口 大千公告-->
    <component :is="sdkNotice"></component>
    <!--组件 客服-->
    <component :is="kefu"></component>
    <!-- 浮标 -->
    <keep-alive>
      <component :is="floatBall"></component>
    </keep-alive>
    <!-- 侧边栏 -->
    <component :is="slideBar"></component>
    <!-- 横竖屏提示 -->
    <component :is="screen.name"></component>
    <!-- // ios保存桌面提示 -->
    <guide v-if="isShowIosGuide || isGuide" :guide="isGuide" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SDKInit from '@/components/Init'
import AccountLogin from '@/components/login/accountLogin'
import fuseNotice from '@/components/notice/FuseNotice'
import sdkNotice from '@/components/notice/SdkNotice'
import floatBall from '@/components/floatBall'
import slideBar from '@/components/slideBar'
import recharge from '@/components/recharge'
import rechargeIframe from '@/components/recharge-iframe'
import AppleRecharge from '@/components/AppleRecharge'
import screenc from '@/components/common/screen'
import kefu from '@/components/kefu'
import spread from '@/components/spread'
import pageLoading from '@/components/pageLoading'
import guide from '../components/guide.vue'
import '@/fuse/fuse.sdk'
import FN from '../utility/fn'
export default {
  components: {
    init: SDKInit,
    login: AccountLogin,
    fuseNotice,
    floatBall,
    slideBar,
    recharge,
    rechargeIframe,
    AppleRecharge,
    screenc,
    sdkNotice,
    kefu,
    spread,
    pageLoading,
    guide
  },
  data() {
    this.wakeLock = null
    return {
      isGuide: false
    }
  },
  computed: {
    ...mapGetters(['notice', 'SDKComponentMessage', 'floatBall', 'slideBar', 'screen', 'sdkNotice', 'kefu', 'isShowIosGuide', 'isBallMove'])
  },
  created() {
    this.isGuide = FN.getURLparams().guide === '1' && FN.isIOS && FN.isSafari && !FN.isInStandaloneMode
    if (FN.isInStandaloneMode) {
      // pwa模式开启屏幕常亮
      this.bindEvent()
      // 调整窗口大小 (目前两款pwa游戏都是竖屏的)
      window.resizeTo(500, 930)
      // if (!this.SDKComponentMessage.params.isLandscape) {
      //   // 竖屏游戏
      //   window.resizeTo(500, 930)
      // } else {
      //   // 横屏游戏
      //   window.resizeTo(window.screen.availWidth, window.screen.availHeight)
      // }
    }
  },
  methods: {
    async bindEvent() {
      if (!navigator.wakeLock) return
      this.wakeLock = await navigator.wakeLock.request("screen");
      document.addEventListener("visibilitychange", async () => {
        if (document.visibilityState === "visible") {
          this.wakeLock = await navigator.wakeLock.request("screen");
        } else {
          this.wakeLock && this.wakeLock.release()
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.ui {
  position: relative;
  &.move {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
